export class ApiResources {
    static readonly resources = {
        base: "resources",
        roles: "roles",
        clients: "clients",
        contractClients: "contract-clients",
        organizations: "organizations",
        userOrganizations: "user-organizations",
        practices: "practices",
        providers: "providers",
        patients: "patients",
        contracts: "contracts",
        internalOwners: "internal-owners",
        riskTypes: "risk-types",
        measureWeights: "measure-weights",
        attributions: "attributions",
        measures: "measures",
        payers: "payers",
        selectedPayer: "selected-payer",
        formats: "formats",
        reports: "reports",
        templates: "templates",
        contractTemplates: "contract-templates",
        templateVersions: "template-versions",
        contractTemplateVersions: "contract-template-versions",
        templateMeasureGroups: "templates-measure-groups",
        templateTags: "template-tags",
        allTemplateTags: "all-template-tags",
        programs: "programs",
        contractsView: "contracts-view",
        patientContracts: "patient-contracts",
        planning: "planning",
        measureCodes: "measure-codes",
        clientOwners: "client-owners",
        dropDownMeasures: "drop-down-measures",
        clientFeatures: "client-features",
        fetchUserByClient: "fetch-user-by-clientId",
        fetchMipsClient: "mips-clients",
        fetchMeasuresBasedOnFormat: "measures-based-on-format",
        fetchDsripContracts:"fetch-dsrip-contracts",
        fetchActiveContracts: "fetch-active-contracts",
     
    }

    static readonly application = {
        base: "application",
        authenticate: "authenticate",
        refresh: "refresh-authentication",
        resetPassword: "reset-password",
        encrypt: "encrypt",
        updateMaintenance: "update-maintenance",
        encryptObj: "encrypt-object",
        decrypt: "decrypt",
        findClientFeatures:"find-client-features"
    }

    static readonly auditLog = {
        base: "auditLog",
        create: "create"
    };

    static readonly themes = {
        base: "themes",
        fetch: "fetch"
    }

    static readonly selfRegistration = {
        base: "registration",
        saveUser: "save-user-details",
        getState: "get-state",
        getEhrPracticeInfo: "get-ehr-practice-info"
    }

    static readonly runMeasures = {
        base: "runMeasures",
        delete: "delete",
        runMeasures: "run-measures",
        fetchAllMeasures: "fetch-all-measure",
        fetchAuditLog: "fetch-activities",
        checkRunMeasuresStatus: "check-run-measures-status",
        fetchExceptionLog: "fetch-exception-activities"
    }

    static readonly users = {
        base: "users",
        fetch: "fetch",
        fetchUnAssignedUsers: "fetch-unassigned-users",
        AssignUser: "assign-user",
        declineUser: "decline-user",
        add: "add",
        get: "get",
        getByEncryption: "get-by-encryption",
        delete: "delete",
        updateSettings: "update-settings",
        updatePassword: "update-password",
        getClient: "get-client",
        fetchParticipants: "fetch-participants",
        updateClient: "update-client",
        fetchThemes: "fetch-themes",
        updateTheme: "update-theme",
        fetchAbstractorParticipants: "fetch-abstractor-participants",
        fetchAbstractorParticipantsSelected: "fetch-abstractor-participants-selected"
    };

    static readonly clients = {
        base: "clients",
        fetch: "fetch",
        add: "add",
        update: "update",
        delete: "delete",
        updateSettings: "update-settings",
        find: "find",
        get: "get",
        getClients: "get-clients"
    };

    static readonly contractDetails = {
        base: "contract-details",
        fetch: "fetch"
    };

    static readonly contractManager = {
        base: "contract-manager",
        fetch: "fetch",
        fetchForClient: "client-fetch",
        fetchByClient: "fetch-by-client"
    };

    static readonly clientPractices = {
        base: "client-practices",
        fetch: "fetch",
        add: "add",
        update: "update",
        delete: "delete"
    };

    static readonly clientProviders = {
        base: "client-providers",
        fetch: "fetch",
        add: "add",
        update: "update",
        delete: "delete"
    };

    static readonly features = {
        base: "features",
        fetch: "fetch",
        add: "add"
    };

    static readonly clientFeatures = {
        base: "clientFeatures",
        fetch: "fetch",
        add: "add",
        toggle: "toggle"
    };

    static readonly practices = {
        base: "clientFeatures",
        fetch: "fetch",
        add: "add",
        toggle: "toggle"
    };

    static readonly validators = {
        base: "validate",
        email: "email",
        clientEmail: "client-email",
        npi: "npi"
    };

    static readonly organizations = {
        base: "organizations",
        add: "add",
        update: "update",
        delete: "delete",
        fetch: "fetch"
    };

    static readonly templates = {
        base: "templates",
        find: "find",
        fetch: "fetch",
        findDetails: "find-details",
        fetchGoals: "fetch-goals",
        fetchMeasures: "fetch-measures",
        saveDetails: "save-details",
        saveTemplateType: "save-template-type",
        saveMeasures: "save-measures",
        publish: "publish"
    };

    static readonly contracts = {
        base: "contract",
        fetchContractOrganizationsAsync: "fetchContractOrganizationsAsync",
        fetchContractProvidersAsync: "fetchContractProvidersAsync",
        add: "add",
        archiveContract: "archive-contract",
        contractDetails: "contract-details",
        saveMeasures: "save-measures",
        addParticipant: "add-participants",
        publish: "active-is-publish",
        fetchContractDetails: "fetch-contract-details",
        fetchContractGoals: "fetch-contract-goals",
        fetchContractMeasures: "fetch-contract-measures",
        fetchContractParticipant: "fetch-contract-participants",
        find: "find"
    };

    static readonly participants = {
        base: "participants",
        fetchOrganizations: "fetch-organizations",
        fetchPractices: "fetch-practices",
        fetchProviders: "fetch-providers",
        fetchPatients: "fetch-patients",
        fetchPatientMeasures: "fetch-patient-measures",
        fetchPatientsDetails: "fetch-patients-details",
        fetchPatientAppointments: "patient-appointments",
        findClient: "find-client",
        findOrganization: "find-organization",
        findPractice: "find-practice",
        findProvider: "find-provider",
        findPatient: "find-patient",
        InsertPatientComments: "insert-patient-comments"
    };

    static readonly adminContractDetails = {
        base: "client-contract-details",
        fetch: "fetch",
        fetchContractMeasures: "fetch-contract-measures",
        fetchContractParticipants: "fetch-contract-participants"
    };

    static readonly measures = {
        base: "measures",
        find: "find",
        fetch: "fetch",
        fetchParticipants: "fetch-participants",
        fetchProviderParticipants: "fetch-provider-participants",
        fetchPracticeParticipants: "fetch-practice-participants",
        findPatientMeasureDecision: "find-patient-measure-decision",
        updateMeasureStatus: "modify-measure-status",
        updateMeasureDecision: "modify-measure-decision"
    };

    static readonly planning = {
        base: "planning",
        fetchPatientName: "fetch-patient-name",
        fetchPlan: "fetch-plan",
        fetchPatientPlan: "fetch-patient-plan",
        fetchPatientMrns: "fetch-patient-mrns",
        fetchPatientNames: "fetch-patient-names",
        edit: "edit",
        fetchSelectedPlan: "fetch-selected-plan",
        save: "save",
        delete: "delete",
        deletePatient: "delete-patient",
        fetch: "fetch",
        exportToPdf: "export",
        savePlanDetails: "save-plan-details",
        fetchSearchPatient: "fetch-patient-filter"
    };

    static readonly dashboard = {
        base: "dashboard",
        fetch: "fetch",
        fetchSystemContracts: "fetch-system-contracts",
        fetchSystemPerformance: "fetch-system-performance",
        findClient: "find-client",
        fetchClientPerformance: "fetch-client-performance",
        fetchClientMeasures: "fetch-client-measures",
        fetchCareGaps: "fetch-care-gaps",
        fetchDataGaps: "fetch-data-gaps",
        fetchPatientOverview: "fetch-patient-overview"
    };

    static readonly attribution = {
        base: "attribution",
        uploadFile: "upload-file",
        fetchMasters: "fetch-masters",
        deleteMaster: "delete-master",
        findMaster: "find-master",
        fetchDetails: "fetch-details",
    }

    static readonly measureAnalysis = {
        base: "measure-analysis",
        fetch: "fetch",
        fetchActivityReport: "fetch-activity-report",
        exportActivityReport: "export-activity-report"
    };

    static readonly reportActivity = {
        base: "report-activity",
        fetch: "fetch"
    };

    static readonly adminReport = {
        base: "admin-report",
        fetchAuditLogReport: "fetch-auditLog-report",
        exportAuditLogReport: "export-auditLog-report",
        fetchRegisterReport: "fetch-register-report",
        exportRegisterReport: "export-register-report",
        fetchWatchlist: "fetch-watch-list"

    };

    static readonly patientAnalysis = {
        base: "patient-analysis",
        fetchComments: "fetch-comments-report",
        exportComments: "export-comments-report",
        fetchSkipped: "fetch-skipped-report",
        exportSkipped: "export-skipped-report",
        fetchOnWatch: "fetch-on-watch-report"
    };

    static readonly dsripReports = {
        base: "dsrip-reports",
        fetchAnnualPerformance: "fetch-annual-performance",
        exportAnnualPerformance: "export-annual-performance",
        fetchMeasureValidation: "fetch-measure-validation",
        exportMeasureValidation: "export-measure-validation",
        fetchDsripMeasures: "fetch-dsrip-measures"
    };

  static readonly mipsReports = {
    base: "mips-reports",
    fetchMeasureValidationReport: "fetch-measure-validation",
  };

  static readonly qipReports = {
    base: "qip-reports",
    fetchQipClient: "qip-clients",
    fetchQipMeasures: "qip-measures",
    fetchQipReport: "fetch-qip-report",
    fetchQipContracts: "qip-contracts",
    fetchQipPerformanceReport: "fetch-qip-performance-report",
    updateQipReport: "update-qip-report"
  };


  static readonly list = {
    base: "list",
    uploadFile: "upload-file",
    uploadList: "upload-list",
    fetchMasters: "fetch-masters",
    deleteMaster: "delete-master",
    findMaster: "find-master",
    fetchDetails: "fetch-details",
    addDetails: "add-details",
    deleteDetails: "delete-details",
    assignList: "assign-list",
    fetchListMeasures: "fetch-list-measures",
    removeList: "remove-list",
  }
}
